export default __webpack_public_path__ + "static/media/service-9.f102c6c4.jpg";